import { t } from "@lingui/macro";
import { add, format, parse } from "date-fns";

import { BlockIcon } from "@whoosh/design-system/src/components/icons_v2/general/icons/BlockIcon";
import { dateUtils } from "@whoosh/utilities";
import {
  CustomColor,
  getSurfaceColor,
  getTextColor,
} from "@whoosh/utilities/src/colors";

import { TimeListInfoCard } from "../TimeListInfoCard";

export type TimeListBlockProps = {
  name: string;
  startAt: string | null;
  color: CustomColor;
  durationMins: number;
  courseMessage: string;
};

export const TimeListBlock = ({
  name,
  startAt,
  color,
  durationMins,
  courseMessage,
}: TimeListBlockProps) => {
  const formatStartTime = startAt ? dateUtils.formatHHMM(startAt) : "";

  const endAt =
    startAt &&
    add(parse(startAt, "HH:mm:ss", new Date()), { minutes: durationMins ?? 0 });

  const formatEndTime = endAt ? format(endAt, "h:mm aaa") : "";

  const times = startAt ? `${formatStartTime} - ${formatEndTime}` : "";
  return (
    <TimeListInfoCard
      title={t`Blocked`}
      subTitle={times}
      bodyTitle={name}
      backgroundColor={getSurfaceColor(color)}
      titleColor={getTextColor(color)}
      bodyColor={getTextColor(color)}
      icon={<BlockIcon />}
      courseMessage={courseMessage}
    />
  );
};
